import React, { useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { useEffect } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

const PricingPage = () => {
  const { user } = useContext(AuthContext);
  const [billingCycle, setBillingCycle] = useState("monthly");
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [showHeartBreak, setShowHeartBreak] = useState(false);

  
const handlePurchase = async (itemPriceId, targetPlan) => {
  if (!user) {
    setPopupMessage("⚠️ Please log in to purchase a plan.");
    setShowPopup(true);
    return;
  }

  if (targetPlan === "trial" && user?.hasUsedTrial) {
    setPopupMessage("⚠️ You've already used your trial plan.");
    setShowPopup(true);
    return;
  }

  if (targetPlan === "trial" && activePlan === "gold") {
    setPopupMessage("⛔ Trial plan is not available because you already have a Gold plan.");
    setShowPopup(true);
    return;
  }

  if (targetPlan === "standard" && activePlan === "gold") {
    setPopupMessage("⛔ You're already on a higher plan (Gold). Please continue with Gold or cancel your subscription first.");
    setShowPopup(true);
    return;
  }

  if (targetPlan === "gold" && activePlan === "gold") {
    setPopupMessage("⛔ You already have the Gold plan active.");
    setShowPopup(true);
    return;
  }

  try {
    const res = await fetch("https://api.styleuai.com/pricing/api/check-plan", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: user.email, targetPlan }),
    });

    const data = await res.json();

    if (!res.ok) {
      setPopupMessage(`⛔ ${data?.error || "Plan check failed. Please try again later."}`);
      setShowPopup(true);
      return;
    }

    const site = process.env.REACT_APP_CHARGEBEE_SITE;
    const email = encodeURIComponent(user.email);
    const redirectUrl = encodeURIComponent("https://login.styleuai.com/PricingPlan");
    const checkoutUrl = `https://${site}.chargebee.com/hosted_pages/checkout?subscription_items[item_price_id][0]=${itemPriceId}&subscription_items[quantity][0]=1&customer[email]=${email}&redirect_url=${redirectUrl}`;
    window.location.href = checkoutUrl;
  } catch (err) {
    console.error("💥 API Error:", err);
    setPopupMessage("❌ Something went wrong while verifying your plan.");
    setShowPopup(true);
  }
};

const [currency, setCurrency] = useState("USD"); // Default
const currencySymbol = currency === "INR" ? "₹" : currency === "USD" ? "$" : "AED ";
useEffect(() => {
  const fetchCurrency = async () => {
    try {
      const res = await fetch("https://ipapi.co/json/");
      const data = await res.json();
      if (data && data.country) {
        if (data.country === "US") setCurrency("USD");
        else if (data.country === "AE") setCurrency("AED");
        else setCurrency("INR");
      }
    } catch (err) {
      console.warn("🌐 Failed to detect location. Defaulting to INR.");
      setCurrency("INR");
    }
  };

  fetchCurrency();
}, []);


const handleSubscriptionCancel = async () => {
  if (!subscriptionId) {
    setPopupMessage("❌ No subscription ID found. Cannot cancel.");
    setShowPopup(true);
    return;
  }

  try {
    const res = await fetch("https://api.styleuai.com/pricing/api/cancel-subscription", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ subscriptionId }),
    });

    const result = await res.json();
    setPopupMessage(result.message || "Cancellation submitted.");
    setShowCancelModal(false);
    setShowPopup(true);
    setShowHeartBreak(true);  // 💔 show the heart effect
  } catch {
    setPopupMessage("❌ Failed to cancel subscription.");
    setShowPopup(true);
  }
};



 const plans = {
  standard: {
    monthly: {
      INR: { price: 3999, id: "SP-INR-Monthly", oldPrice: 4999 },
      USD: { price: 89, id: "SP-USD-Monthly", oldPrice: 99 },
      AED: { price: 299, id: "SP-AED-Monthly", oldPrice: 329 },
    },
    yearly: {
      INR: { price: 2999, id: "SP-Yearly-INR-Yearly", oldPrice: 4999 },
      USD: { price: 69, id: "SP-Yearly-USD-Yearly", oldPrice: 99 },
      AED: { price: 249, id: "SP-Yearly-AED-Yearly", oldPrice: 329 },
    }
  },
  gold: {
    monthly: {
      INR: { price: 11999, id: "GP-INR-Monthly", oldPrice: 14999 },
      USD: { price: 299, id: "GP-USD-Monthly", oldPrice: 349 },
      AED: { price: 999, id: "GP-AED-Monthly", oldPrice: 1299 },
    },
    yearly: {
      INR: { price: 9999, id: "GP-Yearly-INR-Yearly", oldPrice: 14999 },
      USD: { price: 249, id: "GP-Yearly-USD-Yearly", oldPrice: 349 },
      AED: { price: 749, id: "GP-Yearly-AED-Yearly", oldPrice: 1299 },
    }
  },
  trial: {
  monthly: {
    INR: { price: 100, id: "Trial-Plan-INR-Monthly" },
    USD: { price: 1.5, id: "Trial-USD-Monthly" },
    AED: { price: 10, id: "Trial-AED-Monthly" }
  }
},
};

  const [activePlan, setActivePlan] = useState(null);
const [subscriptionId, setSubscriptionId] = useState(null);
const isDesktop = window.innerWidth >= 768;
useEffect(() => {
  let isMounted = true;

  const fetchUserData = async () => {
    if (!user || !user.uid) {
      setActivePlan(null);
      setSubscriptionId(null);
      return;
    }

    try {
      const uid = user.uid;
      const userRef = doc(db, "users", uid);
      const userSnap = await getDoc(userRef);

      if (!isMounted || !user || user.uid !== uid) return;

      if (userSnap.exists()) {
        const data = userSnap.data();
        setActivePlan(data.activePlan?.toLowerCase() || null);
        setSubscriptionId(data.chargebeeSubscriptionId || null);
        setSubscriptionStatus(data.subscriptionStatus || null);
        console.log("Loaded user data:", data);
      } else {
        setActivePlan(null);
        setSubscriptionId(null);
        setSubscriptionStatus(null);
      }
    } catch (error) {
      if (isMounted) {
        console.error("❌ Firestore fetch error:", error.message);
      }
    }
  };

  fetchUserData();

  return () => {
    isMounted = false;
  };
}, [user]);


  return (
 <div className="flex min-h-screen bg-gray-50">
  {/* Sidebar (always rendered, hidden via Tailwind on mobile) */}
  <div className="hidden md:block">
    <Sidebar />
  </div>

  {/* Main Content Area */}
  <div className="flex-1 flex flex-col w-full">
    {/* Header always visible at top */}
    <Header />

    {/* Sidebar for mobile (only shown in small screens) */}
    <div className="block md:hidden">
      <Sidebar />
    </div>

    {/* Main content area */}
    <main className="pricing-main">

  <div className="text-center mb-10">
    <p className="text-sm uppercase text-[#3913C5] font-semibold">💡 AI Photo Plans</p>
    <h1 className="text-4xl font-extrabold mt-2">Select the perfect plan</h1>
    <p className="text-gray-500 mt-2">Unlock powerful AI tools for Fashion</p>
    <div className="mt-6 flex justify-center items-center space-x-3">
      <span className={billingCycle === "monthly" ? "text-[#3913C5] font-semibold" : "text-gray-500"}>Monthly</span>
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={billingCycle === "yearly"}
          onChange={() => setBillingCycle(prev => (prev === "monthly" ? "yearly" : "monthly"))}
        />
        <div className="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-[#3913C5] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full"></div>
      </label>
      <span className={billingCycle === "yearly" ? "text-[#3913C5] font-semibold" : "text-gray-500"}>Yearly</span>
    </div>
  </div>

  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
    {/* TRIAL PLAN */}
    <div className={`relative bg-yellow-50 border border-yellow-300 rounded-2xl p-6 shadow-md transition hover:scale-[1.02] duration-300 ${activePlan === "trial" ? "ring-2 ring-yellow-500" : ""}`}>
      {activePlan === "trial" && (
        <span className="absolute top-4 right-4 bg-yellow-100 text-yellow-700 text-xs font-semibold px-3 py-1 rounded-full shadow">✔ Active</span>
      )}
      <p className="text-yellow-600 font-semibold text-lg">Trial</p>
      <p className="mt-1 text-gray-400 line-through text-sm">{currencySymbol}3</p>
      <p className="text-3xl font-bold">{currencySymbol}{plans.trial.monthly[currency]?.price} <span className="text-sm text-gray-500">/ month</span></p>
      <button
        onClick={() => handlePurchase(plans.trial.monthly[currency]?.id, "trial")}
        disabled={activePlan === "trial" || user?.hasUsedTrial}
        className={`w-full mt-4 py-2 font-semibold rounded-lg transition ${
          activePlan === "trial" || user?.hasUsedTrial
            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
            : "bg-yellow-500 text-white hover:bg-yellow-600"
        }`}
      >
        {activePlan === "trial"
          ? "✔ Active Plan"
          : user?.hasUsedTrial
          ? "⛔ Trial Unavailable"
          : "🎉 Start Trial"}
      </button>
      <ul className="mt-6 space-y-1 text-sm text-gray-600">
        <li>✔ 10 Credits (Once Only)</li>
        <li>✔ eFitting - AI Try-on</li>
        <li>✔ Background Remover</li>
        <li>✔ Access to Founder</li>
        <li>❌ SEO, Enhancer, Influencer AI</li>
        <li>❌ Commercial Use</li>
        <li>❌ Design Requests</li>
      </ul>
    </div>

    {/* STANDARD PLAN */}
    <div className={`relative bg-[#F5F2FF] border rounded-2xl p-6 shadow-md transition hover:scale-[1.02] duration-300 ${activePlan === "standard" ? "ring-2 ring-green-300" : ""}`}>
      {activePlan === "standard" && (
        <span className="absolute top-4 right-4 bg-green-100 text-green-700 text-xs font-semibold px-3 py-1 rounded-full shadow">✔ Active</span>
      )}
      <p className="text-purple-600 font-semibold text-lg">Standard</p>
      <p className="mt-1 text-gray-400 line-through text-sm">{currencySymbol}{plans.standard[billingCycle][currency]?.oldPrice}</p>
      <p className="text-3xl font-bold">{currencySymbol}{plans.standard[billingCycle][currency]?.price}<span className="text-sm text-gray-500"> /month</span></p>
      <button
        onClick={() => handlePurchase(plans.standard[billingCycle][currency]?.id, "standard")}
        disabled={activePlan === "standard"}
        className={`w-full mt-4 py-2 font-semibold rounded-lg transition ${
          activePlan === "standard"
            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
            : "bg-[#3913C5] text-white hover:bg-purple-700"
        }`}
      >
        {activePlan === "standard"
          ? "✔ Active Plan"
          : "✨ Get Standard"}
      </button>
      <ul className="mt-6 space-y-1 text-sm text-gray-600">
        <li>✔ 100 Credits / Month</li>
        <li>✔ eFitting - AI TryOn</li>
        <li>✔ Background Enhancer</li>
        <li>✔ Background Remover</li>
        <li>✔ Unlimited Models/Garments</li>
        <li>✔ Image Enhancer</li>
        <li>✔ Commercial Use</li>
        <li>✔ No Watermark</li>
        <li>✔ Access to Founder</li>
      </ul>
    </div>

    {/* GOLD PLAN */}
    <div className={`relative bg-[#F5F2FF] border-4 border-[#3913C5] rounded-2xl p-6 shadow-md transition hover:scale-[1.02] duration-300 ${activePlan === "gold" ? "ring-2 ring-yellow-300" : ""}`}>
      <span className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#3913C5] text-white text-xs px-3 py-1 rounded-full shadow">Most Popular</span>
      {activePlan === "gold" && (
        <span className="absolute top-4 right-4 bg-yellow-100 text-yellow-700 text-xs font-semibold px-3 py-1 rounded-full shadow">✔ Active</span>
      )}
      <p className="text-purple-600 font-semibold text-lg">Gold</p>
      <p className="mt-1 text-gray-400 line-through text-sm">{currencySymbol}{plans.gold[billingCycle][currency]?.oldPrice}</p>
      <p className="text-3xl font-bold">{currencySymbol}{plans.gold[billingCycle][currency]?.price}<span className="text-sm text-gray-500"> /month</span></p>
      <button
        onClick={() => handlePurchase(plans.gold[billingCycle][currency]?.id, "gold")}
        disabled={activePlan === "gold"}
        className={`w-full mt-4 py-2 font-semibold rounded-lg transition ${
          activePlan === "gold"
            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
            : "bg-[#3913C5] text-white hover:bg-purple-700"
        }`}
      >
        {activePlan === "gold"
          ? "✔ Active Plan"
          : "🚀 Upgrade to Gold"}
      </button>
      <ul className="mt-6 space-y-1 text-sm text-gray-600">
        <li>✔ 300 Credits / Month</li>
        <li>✔ eFitting - AI TryOn</li>
        <li>✔ Background Enhancer</li>
        <li>✔ Background Remover</li>
        <li>✔ Unlimited Models/Garments</li>
        <li>✔ Image Enhancer</li>
        <li>✔ Commercial Use</li>
        <li>✔ SEO Content</li>
        <li>✔ Influencer AI Shots – Coming Soon!</li>
        <li>✔ 25 Design Requests</li>
        <li>✔ No Watermark</li>
        <li>✔ Access to Founder</li>
      </ul>
    </div>

    {/* BUSINESS PLAN */}
    <div className="bg-[#F5F2FF] rounded-2xl shadow-md border border-gray-200 p-6 flex flex-col hover:scale-[1.02] transition duration-300">
      <p className="text-purple-600 font-semibold text-lg">Business</p>
      <p className="text-sm italic text-gray-500 mt-1">Bulk images to be processed? Contact us now!</p>
      <p className="text-3xl font-bold mt-2">Custom Pricing</p>
      <a
        href="https://calendly.com/hello-styleuai/30min"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-4 text-center bg-gray-900 text-white py-2 rounded-lg hover:bg-gray-800 transition"
      >
        Book 1:1 Meeting
      </a>
      <ul className="mt-6 space-y-1 text-sm text-gray-600">
        <li>✔ Everything ++</li>
        <li>✔ Team Manages Everything</li>
        <li>✔ Bulk Image Processing</li>
        <li>✔ QA Review & Fast Delivery</li>
        <li>✔ Dedicated Manager</li>
        <li>✔ Commercial Use</li>
      </ul>
    </div>
  </div>
     {activePlan && activePlan !== "free" && (
  <div className="mt-6">
<button
  onClick={() => setShowCancelModal(true)}
  disabled={subscriptionStatus === "cancel_scheduled"}
  className={`py-2 px-4 rounded font-semibold transition ${
    subscriptionStatus === "cancel_scheduled"
      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
      : "bg-red-600 text-white hover:bg-red-700"
  }`}
>
  {subscriptionStatus === "cancel_scheduled"
    ? "Cancellation Scheduled"
    : "Cancel Subscription"}
</button>

  </div>
)}

</main>
      </div>

      {/* POPUP MODAL */}
{showPopup && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
    <div className="bg-white rounded-xl shadow-xl p-6 max-w-md w-full">
      <h2 className="text-lg font-bold text-gray-800 mb-2">⚠️ Notice</h2>

      {showHeartBreak && (
        <div className="flex justify-center mb-4">
          <span
            className="text-6xl text-red-600"
            style={{
              animation: "heartBreak 1.2s ease-out forwards"
            }}
          >
            💔
          </span>
        </div>
      )}

      <p className="text-sm text-gray-700 whitespace-pre-line">{popupMessage}</p>

      <div className="flex justify-end gap-2 mt-6">
        <button
          onClick={() => {
            setShowPopup(false);
            setShowHeartBreak(false);
          }}
          className="bg-gray-300 hover:bg-gray-400 text-black px-4 py-2 rounded"
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}




{showCancelModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div className="bg-white p-6 rounded-xl max-w-md w-full shadow-xl">
      <h2 className="text-xl font-bold mb-4">Cancel Subscription</h2>
      <p className="text-sm text-gray-700 mb-6">
        Are you sure you want to cancel? Your plan will remain active until the end of current billing period.
      </p>
      <div className="flex justify-end gap-2">
        <button onClick={() => setShowCancelModal(false)} className="px-4 py-2 bg-gray-300 rounded">No</button>
        <button onClick={handleSubscriptionCancel} className="px-4 py-2 bg-red-600 text-white rounded">Yes, Cancel</button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default PricingPage;